export default "/images/framework/Status404.9187cd76.svg?9187cd76";